
import { mapGetters } from "vuex";
import Amplify, { Storage, StorageProvider } from 'aws-amplify';

Amplify.configure({
    Auth: {
        identityPoolId: 'eu-west-2:1a013c1c-3c01-4a47-ad5b-e75ff13dc0eb', //REQUIRED - Amazon Cognito Identity Pool ID
        region: 'eu-west-2', // REQUIRED - Amazon Cognito Region
    },
    Storage: {
        AWSS3: {
            bucket: 'pepa.resources', //REQUIRED -  Amazon S3 bucket name
            region: 'eu-west-2', //OPTIONAL -  Amazon service region
        }
    }
});

const STATUS_INITIAL = 0;
const STATUS_SAVING = 1;
const STATUS_SUCCESS = 2;
const STATUS_COMPLETE = 3;
const STATUS_FAILED = 4;

export const fileResourceMixin = {
    computed: {
        ...mapGetters({ currentUser: "currentUser" }),
        isInitial() {
            return this.currentStatus === STATUS_INITIAL;
          },
          isSaving() {
            return this.currentStatus === STATUS_SAVING;
          },
          isSuccess() {
            return this.currentStatus === STATUS_SUCCESS;
          },
          isComplete() {
            return this.currentStatus === STATUS_COMPLETE;
          },
          isFailed() {
            return this.currentStatus === STATUS_FAILED;
          },
    },
    data() {
        return {
            completedPercentage: 0,
            currentStatus: null,
            remoteName: '',
            fileName: ''
        }
    },
    mounted() {
        this.currentStatus = STATUS_INITIAL;
      },
    methods: {
        async getFileByType(remoteName, type) {
            const filePath = type + "/" + remoteName.trim();
            return await Storage.get(filePath, {
                customPrefix: {
                    public: ''
                },
            })
        },
        async getFileDataByType(remoteName, type) {
            const filePath = type + "/" + remoteName.trim();
            return await Storage.get(filePath, { 
                download: true,
                customPrefix: {
                    public: ''
                },
            });
        },
        async getDocument(remoteName) {
            const filePath = "documents/" + remoteName.trim();

            return await Storage.get(filePath, {
                customPrefix: {
                    public: ''
                },
            })
        },
        async getDocumentData(remoteName) {
            const filePath = "documents/" + remoteName.trim();
            return await Storage.get(filePath, { 
                download: true,
                customPrefix: {
                    public: ''
                },
            });
        },
        async getLessonDocumentData(remoteName) {
            const filePath = "teaching/" + remoteName.trim();
            return await Storage.get(filePath, { 
                download: true,
                customPrefix: {
                    public: ''
                },
            });
        },
        async getLessonDocument(remoteName) {
            const filePath = "teaching/" + remoteName.trim();

            return await Storage.get(filePath, {
                customPrefix: {
                    public: ''
                },
            })
        },
        async getDiagram(remoteName) {
            const filePath = "diagrams/" + remoteName.trim();

            return await Storage.get(filePath, {
                customPrefix: {
                    public: ''
                },
            })
        },
        async getAvatar(remoteName) {
            const filePath = "avatars/" + remoteName.trim();

            return await Storage.get(filePath, {
                customPrefix: {
                    public: ''
                },
            })
        },
        async uploadDocument(bucketFolder, formData, subFolder) {
            this.currentStatus = STATUS_SAVING;
            var vm = this

            const files = formData.getAll('file');

            var file = files[0];
            var ext =
            Math.random()
                .toString(36)
                .substring(2, 9) +
            "." +
            file.name.split(".").pop();
            this.fileName = file.name.replace(/\.[^/.]+$/, "_") + ext;
            this.fileName =  this.fileName.toLowerCase().replace(/\s+/g,"_")

            if (subFolder.length > 0) {
                this.remoteName = subFolder + "/" + this.fileName;
            } else {
                var path = "U" + this.wordNumericValue(this.currentUser.schoolID);
                this.remoteName = path + "/" + this.fileName;
            }

            const filePath = bucketFolder + "/" + this.remoteName.trim();

            return await Storage.put(filePath, file, {
                ACL: 'private',
                contentType: file.type,
                ServerSideEncryption: "AES256",
                customPrefix: {
                    public: ''
                },

                progressCallback(progress) {
                    vm.completedPercentage = (progress.loaded * (100 / progress.total)).toFixed(0)
                    if (progress.loaded >= progress.total) {
                        vm.currentStatus = STATUS_COMPLETE;
                    }
                },
            });
        },
        wordNumericValue(n) {
            var alpha = "abcdefghijklmnopqrstuvwxyz".split("");
            var digits = Array.from(n.toString()).map(Number);

            var value = digits
                .map(v => {
                    if (v >= 25) return "";
                    return alpha[v];
                })
                .join("");

            var name = "pep" + value;
            return name.toUpperCase();
        },
        refreshUpload() {
            this.currentStatus = STATUS_INITIAL;
            this.file = ''
            this.remoteName = ''
        },
        completed() {
            this.currentStatus = STATUS_COMPLETE
        }

    },
}